module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("药品基本信息")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": _vm.labelPosition,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "药品名称:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入药品名称"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入药部分:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入入药部分"
    },
    model: {
      value: (_vm.medicineInpart),
      callback: function($$v) {
        _vm.medicineInpart = $$v
      },
      expression: "medicineInpart"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入单位"
    },
    model: {
      value: (_vm.unit),
      callback: function($$v) {
        _vm.unit = $$v
      },
      expression: "unit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "零售价:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入零售价"
    },
    model: {
      value: (_vm.retailPrice),
      callback: function($$v) {
        _vm.retailPrice = $$v
      },
      expression: "retailPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "成本价:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入成本价"
    },
    model: {
      value: (_vm.costPrice),
      callback: function($$v) {
        _vm.costPrice = $$v
      },
      expression: "costPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "药品库存数量:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入药品库存数量"
    },
    model: {
      value: (_vm.number),
      callback: function($$v) {
        _vm.number = $$v
      },
      expression: "number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产地:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入产地"
    },
    model: {
      value: (_vm.manufacturer),
      callback: function($$v) {
        _vm.manufacturer = $$v
      },
      expression: "manufacturer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "药品状态:"
    }
  }, [
    [_c('el-radio-group', {
      on: {
        "change": _vm.choice
      },
      model: {
        value: (_vm.radio),
        callback: function($$v) {
          _vm.radio = $$v
        },
        expression: "radio"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 0
      }
    }, [_vm._v("启用")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": -1
      }
    }, [_vm._v("停用")])], 1)]
  ], 2)], 1), _vm._v(" "), _c('h4', {
    staticStyle: {
      "height": "35px",
      "line-height": "35px"
    }
  }, [_vm._v("预警")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": _vm.labelPosition,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "库存预警:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入库存预警"
    },
    model: {
      value: (_vm.inventoryWarning),
      callback: function($$v) {
        _vm.inventoryWarning = $$v
      },
      expression: "inventoryWarning"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "operation"
  }, [_c('el-button', {
    staticClass: "preserve",
    attrs: {
      "icon": "el-icon-download",
      "type": "primary"
    },
    on: {
      "click": _vm.preservation
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-back",
      "plain": true,
      "type": "info"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03ea70b5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pharmacy/newdrugs.vue
// module id = 991
// module chunks = 2